<template>
  <div>
    <div id="main-content" :key="entry.text" v-for="entry in texts">
      <TextContainer
        v-if="entry.text.length < 700"
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:title="entry.title"
      />

      <BigTextContainer
        v-else
        :src="entry.imgPath"
        v-bind:id="entry.id"
        v-bind:content="entry.text"
        v-bind:orientation="entry.orientation"
        v-bind:title="entry.title"
      />
    </div>
  </div>
</template>

<script>
import TextContainer from "../components/TextContainer";
import BigTextContainer from "../components/BigTextContainer";
export default {
  name: "Contact",
  components: {
    BigTextContainer,
    TextContainer
  },
  data() {
    return {
      page: "contact",
      texts: [],
      texts2: [
        {
          title: "Contact",
          text: `<p>Bestuur Bob Vlake Foundation (BVF),
          <br />
          Keizersgracht 166,
          <br />
          1015CZ Amsterdam,
          </p>
          <p>
          tel. 0619006080,
          <br />
          tel. 0653555171,
          </p>
          <p>
          website (nog te bepalen) TEST
          </p>
          Bankrekening ABN AMRO (nog te bepalen)`,
          imgPath: null,
          orientation: true
        }
      ]
    };
  },
  created() {
    this.$api
      .get(`/maintext/page/${this.page}`)
      .then(response => (this.texts = response.data));
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue